import React from 'react';
import { Play } from 'lucide-react';
import { getVideoThumbnail } from '../../utils/videoUtils';
import { formatDuration } from '../../utils/videoUtils';

function LessonThumbnailSection({ lesson, onClickLesson }) {
  const displayThumbnail = getVideoThumbnail(lesson.video_url, lesson) || '/default_video.png';

  const handleImageError = (e) => {
    if (e.target.src.includes('/default_video.png')) return;
    e.target.onerror = null;
    e.target.src = '/default_video.png';
  };

  const handleImageLoad = (e) => {
    if (e.target) e.target.style.opacity = '1';
  };

  return (
    <div
      className="relative h-48 bg-gradient-to-br from-gray-100 to-gray-200 cursor-pointer overflow-hidden group"
      onClick={() => onClickLesson && onClickLesson(lesson?.id)}
    >
      <img
        src={displayThumbnail}
        alt={lesson.title}
        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        onError={handleImageError}
        onLoad={handleImageLoad}
      />

      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
        <Play size={40} className="text-white" fill="white" />
      </div>

      {lesson.duration && (
        <div className="absolute bottom-2 right-2 bg-black/70 text-white px-2 py-1 rounded text-xs font-bold">
          {formatDuration(lesson.duration)}
        </div>
      )}
    </div>
  );
}

export default LessonThumbnailSection;
